import React from 'react';
import Div from "@jumbo/shared/Div";
import { LEADS } from 'app/utils/constants/endPoint';
import DataTable from 'app/components/DataTable/DataTable';
import { requestApi } from 'app/utils/RestApi';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

// end of style table	

const MicrositeHistoryPayment = () => {
	const navigate = useNavigate()

	React.useEffect(() => {
		fetchData()
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	const [total, setTotal] = React.useState(0);

	const fetchData = async () => {
		const userdata = localStorage.getItem('userdata')
		const dataLogin = JSON.parse(userdata)
		
		await requestApi(LEADS.PAYMENT_HISTORY_CALCULATE, {
			subfolder: '/' + dataLogin.userLoggedin.referrerCode
		}).then((res) => {
			setTotal(res.data.data)
		}).catch((err) => {
			console.log("PAYMENT_HISTORY_CALCULATE err : ", err)
		})
	}

	const customContent = <Div className='grandtotal-container'><h6 className='mb-0'>Grand Total : <span className='grandtotal-value'>{new Intl.NumberFormat('de-DE', {
		maximumFractionDigits: 0
	}).format(total)}</span></h6></Div>;


	const columns = [
		{ field: 'id', headerName: 'No', width: isMobile ? 100 : 40 },
		{ field: 'paymentDueDate', headerName: 'Tanggal Bayar', minWidth: isMobile ? 170 : 150, flex: 1, },
		{
			field: 'commissionReferral', headerName: 'Jumlah Fee (Gross)', minWidth: 150, flex: 1,
			valueFormatter: (params) => {
				const valueFormatted = new Intl.NumberFormat('de-DE', {
					maximumFractionDigits: 0
				}).format(params.value);

				return valueFormatted;
			}
		},
		{
			field: 'policyOwner', headerName: 'Nama Lead', width: 200,
			renderCell: (params) => (
				<div style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => navigate('/micrositeHistoryPaymentPerLead?id=' + params?.row?.policyNo + '&name=' + params.value)}>
					{params.value}
				</div>
			)
		},
		{ field: 'caseNo', headerName: 'Case No', width: isMobile ? 130 : 100 },
		// { field: 'policyStatus', headerName: 'Policy Status', minWidth: 100, flex: 1 },
		{ field: 'issuedDate', headerName: 'Tgl. Issued', width: 200 },
		{
			field: 'commissionReferralRate', headerName: 'Fee Rate', width: isMobile ? 130 : 100,
			valueFormatter: (params) => {
				const valueFormatted = new Intl.NumberFormat('de-DE', {
					maximumFractionDigits: 0
				}).format(params.value);

				return valueFormatted;
			}
		}
	]
	const filterData = [{
		id: "policyOwner",
		name: "Nama Lead"
	}, {
		id: "commissionReferral",
		name: "Fee"
	}]

	return (
		<Div className='content-padding'>
			<Div className='white-container'>
				<Div className='section-header'>History Payment</Div>
				<Div sx={{ overflowX: 'auto' }}>
					<DataTable columns={columns} endPoint={LEADS.PAYMENT_HISTORY} filterData={filterData} downloadUrl={LEADS.PAYMENT_HISTORY_DOWNLOAD} customContent={customContent} />
				</Div>
			</Div>
		</Div>

	);
};

export default MicrositeHistoryPayment;